import { z } from 'zod';
import * as directoryScheme from './directoryScheme';

export const nameHelper =
  'Vendor name is required. It must have at least 2 characters, max 300 characters, no special characters allowed';
export const nameSchema = directoryScheme.createNameSchema({
  name: 'Vendor Name',
  minLength: 2,
  maxLength: 300,
  allowSpecialChars: false,
  allowNumbers: true,
  required: true,
});

export const phoneHelper = directoryScheme.phoneHelperOptional;
export const phoneSchema = directoryScheme.phoneSchema.optional();

export const emailHelper = directoryScheme.emailHelperOptional;
export const emailSchema = directoryScheme.emailSchema.optional();

export const addressHelper = directoryScheme.addressHelperOptional;
export const addressSchema = directoryScheme.addressSchema.optional();

export const countryHelper = directoryScheme.countryHelperOptional;
export const countrySchema = directoryScheme.countrySchema.optional();

export const zipcodeHelper = directoryScheme.zipcodeHelperOptional;
export const zipcodeSchema = directoryScheme.zipcodeSchema.optional();

export const vendorSchema = z.object({
  name: nameSchema,
  address: addressSchema,
  country: countrySchema,
  phone: phoneSchema,
  email: emailSchema,
});

export const vendorPartialSchema = vendorSchema.partial();
